<template>
    <ProfileView
        :title="pageTitle"
        :subtitle="$t('user_profile.subtitle')"
        :loading="loading"
        :user="profile && profile.user"
        :stats="profile && profile.stats"
        :notification-preferences="profile && profile.notification_preferences ? profile.notification_preferences : []"
        :histories="profile && profile.histories"
    >
        <template v-if="profile" #actions>
            <router-link to="/company/users" class="up-link-btn up-link-btn--ghost">
                <i class="fal fa-arrow-left"></i>
                {{ $t('user_profile.back_to_list') }}
            </router-link>
            <router-link
                :to="`/company/user/${profile.user.id}/edit`"
                class="up-link-btn up-link-btn--primary"
            >
                <i class="fal fa-pen"></i>
                {{ $t('common.edit') }}
            </router-link>
        </template>
    </ProfileView>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions } from 'vuex'
import ProfileView from '@/components/UI/ProfileView.vue'

export default {
    name: 'UserProfile',
    components: { ProfileView },
    data() {
        return {
            loading: true,
            profile: null
        }
    },
    computed: {
        pageTitle() {
            return this.profile && this.profile.user
                ? this.profile.user.name
                : this.$t('user_profile.title')
        }
    },
    created() {
        this.getUserProfile(this.$route.params.userId)
            .then((data) => {
                this.profile = data
            })
            .catch((e) => {
                this.$store.dispatch('dispatchError', e)
            })
            .finally(() => {
                this.loading = false
            })
    },
    methods: {
        ...mapActions('company', ['getUserProfile'])
    }
}
</script>

<style scoped>
.up-link-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 36px;
    padding: 0 16px;
    border-radius: var(--v2-radius-md);
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    text-decoration: none !important;
    transition: all var(--v2-transition-fast);
    white-space: nowrap;
    border: 1px solid transparent;
    cursor: pointer;
}

.up-link-btn i {
    font-size: 0.8rem;
}

.up-link-btn--primary {
    background: var(--v2-primary);
    color: #fff !important;
}

.up-link-btn--primary i {
    color: #fff !important;
}

.up-link-btn--primary:hover {
    background: var(--v2-primary-hover, #0e7490);
    box-shadow: var(--v2-shadow-sm);
}

.up-link-btn--ghost {
    background: transparent;
    border-color: var(--v2-border);
    color: var(--v2-text-2);
}

.up-link-btn--ghost:hover {
    border-color: var(--v2-primary);
    color: var(--v2-primary);
    background: rgba(8, 145, 178, 0.04);
}

@media (max-width: 768px) {
    .up-link-btn {
        flex: 1;
        justify-content: center;
    }
}
</style>
